import { render, staticRenderFns } from "./KVDR.vue?vue&type=template&id=261c2d72&scoped=true&"
import script from "./KVDR.vue?vue&type=script&lang=js&"
export * from "./KVDR.vue?vue&type=script&lang=js&"
import style0 from "./KVDR.vue?vue&type=style&index=0&id=261c2d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261c2d72",
  null
  
)

export default component.exports